/**
 * 公開表示設定APIサービス
 *
 * @file public-settings.service.ts
 * @version 1.0.0
 * @author Japan4U Development Team
 * @summary
 * 認証不要の公開API GET /api/v1/public/display-settings から
 * 表示系設定（通知秒数・デフォルト言語等）を取得する。
 */

import { safeFetch } from '@shared/utils/api';

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL;

export interface DisplaySettings {
  homepageNewArrivalsPcLimit: number;
  homepageNewArrivalsMobileLimit: number;
  homepageExternalProductsLimit: number;
  homepageCategoriesLimit: number;
  homepageFeaturedProductsLimit: number;
  errorPageRedirectSeconds: number;
  proxyServices: string[];
  featureChatSupport: boolean;
  notificationDefaultDurationSeconds: number;
  defaultLanguage: string;
  defaultCurrency: string;
}

export async function getPublicDisplaySettings(): Promise<DisplaySettings> {
  return safeFetch<DisplaySettings>(
    `${API_BASE_URL}/api/v1/public/display-settings`,
    { errorMessage: '表示設定の取得に失敗しました。' }
  );
}
